export enum Preference {
  valueProposition = 'valueProposition',
  metrics = 'metrics',
  countries = 'countries',
  language = 'language',
}

export type ValueProposition = {
  painPoint: string;
  valueProposition: string;
};

export type ValuePropResponse = { default: ValueProposition; custom: ValueProposition };

export type MetricLabel = {
  header: string;
  label: string;
  metric: string;
};

export type GroupedMetrics = Record<string, MetricLabel[]>;
